import { FC, ReactElement, memo, ReactNode } from 'react';
import { Status, Wrapper } from '@googlemaps/react-wrapper';
import { GOOGLE_MAPS_API_KEY } from '../../constants/constants';
import { GoogleMap } from './GoogleMap';
import RobotMapOverlay from './RosRobotMap';
import { useRobotDetails } from '../../utilities/RobotDetailsContext';
import { Subscriber } from '../../services/Ros/Subscriber';
import { STATE } from '../../constants/topics';
import { ServiceCaller } from '../../services/Ros/ServiceCaller';
import { RobotStateProvider} from '../../services/Ros/RobotState';

interface IGoogleMapContainer extends google.maps.MapOptions {
    id: string;
    children?: ReactNode;
    onClick?: (e: google.maps.MapMouseEvent) => void; // Add onClick prop
}


const MapContainerMemo: FC<IGoogleMapContainer> = ({ id, children, zoom, center, onClick }) => {
    const {robotDetails} = useRobotDetails();
    const render = (status: Status): ReactElement => {
        if (!robotDetails.isIndoor) {
            switch (status) {
                case Status.LOADING:
                    console.log(status)
                    return <div>Loading...</div>;
                case Status.FAILURE:
                    console.log(status)
                    return <div>Failed to load</div>;
                default:
                        return (
                            <RobotStateProvider>
                                <GoogleMap
                                    id={id}
                                    center={center}
                                    zoom={zoom}
                                    onClick={onClick} // Pass onClick prop
                                    mapTypeId='satellite'
                                    disableDefaultUI={true}
                                >
                                    {children}
                                </GoogleMap>
                            </RobotStateProvider>
                        );
                    }
        }else{
            return(
                <Subscriber name={STATE.name} type={STATE.type} rate={STATE.throttle}>
                    <ServiceCaller name="/state_request_service" type="std_srvs/srv/Trigger">
                        <RobotMapOverlay buttons={true}/>
                    </ServiceCaller>
                </Subscriber>
            )
        }
        
    };

    return (
        <Wrapper apiKey={GOOGLE_MAPS_API_KEY} render={render} libraries={['places']}>
            {/* Render GoogleMap component based on status */}
        </Wrapper>
    );
};

export const MapContainer = memo(MapContainerMemo);
